import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const liveRoutes: RouteObject = {
	path: "live/*",
	lazy: async () => {
		const { LiveDashboard } = await import("./pages");
		return {
			Component: () => (
				<Sentry.ErrorBoundary
					fallback={({ error, componentStack, resetError }) => (
						<PageError
							error={error}
							componentStack={componentStack}
							reset={resetError}
						/>
					)}
				>
					<LiveDashboard />
				</Sentry.ErrorBoundary>
			),
		};
	},
	children: [
		{
			index: true,
			lazy: async () => {
				const { LiveDashboard } = await import("./pages");
				return { Component: LiveDashboard };
			},
		},
	],
};
